<template>
  <div class="page">
    <template v-if="this.$route.query.category === searchCategory.provider">
      <search-provider></search-provider>
    </template>

    <template v-else-if="this.$route.query.category === searchCategory.document">
      <search-document></search-document>
    </template>

    <template v-else-if="this.$route.query.category === searchCategory.contact">
      <search-contact></search-contact>
    </template>

  </div>
</template>

<script>
  import SearchProvider from './SearchProvider';
  import SearchDocument from './SearchDocument';
  import SearchContacts from './SearchContacts'

  export default {
    name: "SearchPage",
    components: {
      'search-provider': SearchProvider,
      'search-document': SearchDocument,
      'search-contact': SearchContacts
    },
    data() {
      return {
        searchCategory: {
          all: 'all',
          provider: 'provider',
          document: 'document',
          contact: 'contact'
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .page {
    /* Was a fixed 700px (≈2 team cards). Widen so My Team can show ~3–4. */
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    box-sizing: border-box;
  }
</style>

<!--todo advanced search -->
